










import { Vue, Component } from 'vue-property-decorator';
import MantenedorTelcosBase from './MantenedorTelcosBase.vue';

@Component({
  components: { MantenedorTelcosBase },
})
export default class MantenedorTelcoPantalla extends Vue {}
